import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "unistore/preact";
import { actions } from "actions";
import { IconShare } from "components/icons/Icons";
import ShareTools from "components/sharing/ShareTools";
import classNames from "classnames";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/sharing/ShareExpandable.scss';

const ShareExpandable = ({ shareableLink, shareBtnText }) => {
  if (!shareableLink) {
    return null;
  }
  const [showShareTools, setShowShareTools] = useState(false);

  // useEffect for shareableLink
  useEffect(() => {
    //Anytime shareableLink changes, we hide the tools
    shareableLink && setShowShareTools(false);
  }, [shareableLink]);

  const onShare = () => setShowShareTools(!showShareTools);

  return (
    <div className="csw-share-expandable">
      <button
        type="button"
        onClick={onShare}
        className={classNames("csw-btn-link csw-share-btn csw-share-tools-btn outline", {
          "csw-show-share-tools": showShareTools,
        })}
        title={shareBtnText}
        aria-label={shareBtnText}
      >
        <span className="csw-btn-txt">{shareBtnText}</span>
        <IconShare iconClassName="csw-share-icon" />
      </button>
      <ShareTools className={showShareTools ? "csw-show-share-tools" : undefined} />
    </div>
  );
};

ShareExpandable.propTypes /* remove-proptypes */ = {
  shareableLink: PropTypes.object,
  shareBtnText: PropTypes.string.isRequired,
};

export default connect("shareableLink", actions)(ShareExpandable);
